/**
 * Test if a given value is NaN
 *
 * @private
 * @param {*} value
 *
 * @returns {boolean}
 */
export function _isDefinitelyNaN (value) {
  // Number.isNaN is more accurate and future-proof, but isn't supported in IE
  if ('isNaN' in Number) {
    return Number.isNaN(value);
  }
  // NaN doesn't equal NaN, because Javascript...
  // eslint-disable-next-line no-self-compare
  return value !== value;
}

export default function (value, mod = 0) {
  const asNumber = parseFloat(value);
  return _isDefinitelyNaN(asNumber) ? '' : asNumber.toFixed(mod);
}
